import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import { useCallback, useContext, useEffect, useState } from "react";
import { CircularProgress, Fab } from "@mui/material";
import { UserNotification } from "../../models/UserNotifications";
import UserNotificationCard from "./components/UserNotificationCard/UserNotificationCard";
import UserNotificationApi from "../../api/user-notification";
import { isEmpty, set } from "lodash";
import { AppContext } from "../../Contexts/AppContext";
import { UserRole } from "../../models/User";
import { useBus, useListener } from "react-bus";
import AddUserNotificationModal from "./components/AddUserNotificationModal/AddUserNotificationModal";
import DeleteUserNotificationModal from "./components/DeleteUserNotificationModal/DeleteUserNotificationModal";

const bull = (
	<Box
		component='span'
		sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}>
		•
	</Box>
);

export default function NotificationsScreen() {
	const [loading, setLoading] = useState(true);
	const [userNotifications, setUserNotifications] = useState<
		UserNotification[]
	>([]);
	const [userNotificationToDelete, setUserNotificationToDelete] =
		useState<UserNotification | null>(null);

	const { userContext, setTitle } = useContext(AppContext);
	const bus = useBus();

	const fetchUserNotifications = useCallback(async () => {
		// Fetch user notifications
		if (!userContext?.permissionaryId) return;
		setLoading(true);

		try {
			const response = await UserNotificationApi.list({
				token: localStorage.getItem("accessToken"),
				permissionaryId: userContext?.permissionaryId || "",
				query: {},
			});
			setUserNotifications(response);
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	}, [userContext]);

	const openUserNotificationToDeleteModal = useCallback(
		(userNotification: UserNotification) => {
			setUserNotificationToDelete(userNotification);
			bus.emit("openDeleteUserNotificationModal");
		},
		[setUserNotificationToDelete, bus]
	);

	useListener("reloadUserNotifications", fetchUserNotifications);

	useEffect(() => {
		fetchUserNotifications();
	}, [fetchUserNotifications]);

	useEffect(() => {
		setTitle("Notificaciones");
	}, [setTitle]);

	return (
		<Box
			sx={{
				textAlign: "center",
				justifyContent: "center",
			}}>
			{loading && <CircularProgress size={100} />}

			<div
				style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
				{!loading && !isEmpty(userNotifications) ? (
					userNotifications.map((userNotification: UserNotification) => {
						return (
							<UserNotificationCard
								key={userNotification._id}
								userNotification={userNotification}
								openUserNotificationToDeleteModal={(
									userNotification: UserNotification
								) => openUserNotificationToDeleteModal(userNotification)}
							/>
						);
					})
				) : (
					<Typography variant='h6'>
						Contactos de emergencia no registrados
					</Typography>
				)}
			</div>
			{userContext?.role === UserRole.ADMIN ||
			userContext?.role === UserRole.GOD ? (
				<Fab
					onClick={() => bus.emit("openAddUserNotificationModal")}
					style={{ position: "fixed", bottom: 50, right: 50 }}
					color='primary'
					aria-label='add'>
					<AddIcon />
				</Fab>
			) : null}
			<AddUserNotificationModal />
			<DeleteUserNotificationModal
				userNotificationToDelete={userNotificationToDelete}
			/>
		</Box>
	);
}
